export const ERROR_MESSAGES = {
  NO_DATA: 'No data available.',
  SERVICE_UNAVAILABLE: 'This service is currently unavailable.',
};
